import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(5 4)" }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m0 1 7 7-7 7" }), /* @__PURE__ */ React.createElement("rect", { width: 2, height: 16, x: 12, fill: "currentColor", rx: 1 })));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
